import { useState, useEffect } from "react";
// @mui
import {
  Box,
  Divider,
  Typography,
  Stack,
  MenuItem,
  IconButton,
  Popover,
} from "@mui/material";
// mocks_
import { Logout, checkAuthToken } from "../../../AuthenticationData.ts";
import { useProfile } from "../../../Context/ProfileContext";
import { useNavigate } from "react-router-dom";
import { useAuthErrorHandler } from "../../../hooks/useAuthErrorHandler";
import FeedbackDialog from "../../../components/FeedbackDialog";
import BetaPioneerDialog from "../../../components/AiAdDialog";

export default function AccountPopover() {
  const { profile } = useProfile();
  const [Account, setAccount] = useState({
    email: "",
    firstName: "",
    lastName: "",
  });
  const [open, setOpen] = useState(null);
  const [feedbackDialogOpen, setFeedbackDialogOpen] = useState(false);
  const [redeemDialogOpen, setRedeemDialogOpen] = useState(false);
  const navigate = useNavigate();
  const { handleAuthError } = useAuthErrorHandler();

  const HandleLogout = async () => {
    try {
      await Logout();

      let isAuthenticated = checkAuthToken();

      if (!isAuthenticated) {
        navigate("/Login");
      } else {
        console.error("Logout failed: User is still authenticated.");
      }
    } catch (error) {
      console.error("Error during logout:", error);
    }
  };
  const handleOpen = (event) => {
    setOpen(event.currentTarget);
  };

  const handleClose = () => {
    setOpen(null);
  };

  useEffect(() => {
    fetchProfileData();
  }, [profile]);

  const fetchProfileData = async () => {
    try {
      setAccount({
        email: profile.email,
        firstName: profile.firstName,
        lastName: profile.lastName,
      });
    } catch (error) {
      if (!handleAuthError(error)) {
        console.error("Error fetching profile data:", error);
      }
    }
  };

  return (
    <>
      <IconButton
        onClick={handleOpen}
        sx={{
          width: 44,
          height: 44,
          borderRadius: '50%',
          padding: '10px',
          transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
          backgroundColor: 'transparent',
          border: '2px solid transparent',
          '&:hover': {
            backgroundColor: (theme) => theme.palette.primary.main,
            borderColor: (theme) => theme.palette.primary.main,
            transform: 'scale(1.1) rotate(90deg)',
            boxShadow: '0 4px 20px rgba(0, 0, 0, 0.15)',
            '& .settings-icon': {
              color: 'white',
              transform: 'scale(1.1)',
            }
          },
          '&:active': {
            transform: 'scale(0.95) rotate(90deg)',
          },
          ...(open && {
            backgroundColor: (theme) => theme.palette.primary.main,
            borderColor: (theme) => theme.palette.primary.main,
            transform: 'scale(1.05) rotate(90deg)',
            '& .settings-icon': {
              color: 'white',
            }
          }),
        }}
      >
        <i
          className="bi bi-gear-fill settings-icon"
          style={{
            fontSize: '20px',
            transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
            color: open ? 'white' : 'inherit'
          }}
        ></i>
      </IconButton>

      <Popover
        open={Boolean(open)}
        anchorEl={open}
        onClose={handleClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
        transformOrigin={{ vertical: "top", horizontal: "right" }}
        PaperProps={{
          sx: {
            mt: 1.5,
            ml: 0.75,
            width: 235,
            "& .MuiMenuItem-root": {
              typography: "body2",
              borderRadius: 0.75,
            },
          },
        }}
      >
        <Box sx={{ my: 1.5, px: 2.5 }}>
          <Typography variant="subtitle2" noWrap>
            {Account.firstName} {Account.lastName}
          </Typography>
          <Typography variant="body2" sx={{ color: "text.secondary" }} noWrap>
            {Account.email}
          </Typography>
        </Box>

        <Divider sx={{ borderStyle: "dashed" }} />

        <Stack sx={{ p: 1 }}>
          {/* <MenuItem onClick={handleClose}>Home</MenuItem> */}
          <MenuItem
            onClick={() => {
              navigate("User");
              handleClose();
            }}
          >
            Studio
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate("ManageCoupons");
              handleClose();
            }}
          >
            Reserve Coupons
          </MenuItem>
          <MenuItem
            onClick={() => {
              setRedeemDialogOpen(true);
              handleClose();
            }}
          >
            Redeem Code
          </MenuItem>

          <MenuItem
            onClick={() => {
              navigate("Settings");
              handleClose();
            }}
          >
            Settings
          </MenuItem>
          <MenuItem
            onClick={() => {
              setFeedbackDialogOpen(true);
              handleClose();
            }}
          >
            Feedback
          </MenuItem>
          <MenuItem
            onClick={() => {
              navigate("Bundles");
              handleClose();
            }}
          >
            Subscription
          </MenuItem>
        </Stack>

        <Divider sx={{ borderStyle: "dashed" }} />

        <MenuItem onClick={HandleLogout} sx={{ m: 1 }}>
          Logout
        </MenuItem>
      </Popover>

      <FeedbackDialog
        open={feedbackDialogOpen}
        onClose={() => setFeedbackDialogOpen(false)}
      />
      <BetaPioneerDialog
        open={redeemDialogOpen}
        onClose={() => setRedeemDialogOpen(false)}
        startWithRedeemOpen={true}
      />

    </>
  );
}
